import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";

import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

export default function DialogCampanhaRecebimentos({
  open,
  onClose,
  recebimentosForm,
  setRecebimentosForm,
  recebimentosLinhas,
  setRecebimentosLinhas,
  historicoRecebimentosCampanha,
  abrirResultado,
  gravarRecebimentos,
  apagarRecebimentoCampanha,
  isAdminLike,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", lg: "1100px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        Registar recebimentos da campanha
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <MDBox
          display="grid"
          gap={2}
          mt={1}
          sx={{
            maxWidth: "100%",
          }}
        >
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 2fr" }} gap={1}>
            <MDInput
              label="Data recebimento"
              type="date"
              value={recebimentosForm.datarecebimento}
              onChange={(e) =>
                setRecebimentosForm((p) => ({ ...p, datarecebimento: e.target.value }))
              }
              fullWidth
              InputLabelProps={{ shrink: true }}
            />

            <MDInput
              label="Documento/ref."
              value={recebimentosForm.docref}
              onChange={(e) => setRecebimentosForm((p) => ({ ...p, docref: e.target.value }))}
              fullWidth
            />

            <MDInput
              label="Observações"
              value={recebimentosForm.obs}
              onChange={(e) => setRecebimentosForm((p) => ({ ...p, obs: e.target.value }))}
              fullWidth
            />
          </MDBox>

          <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems={{ xs: "stretch", md: "center" }}
            flexDirection={{ xs: "column", md: "row" }}
            gap={1}
            sx={{
              "& .MuiButton-root": {
                width: { xs: "100%", sm: "auto" },
              },
            }}
          >
            <MDButton
              color="info"
              onClick={() => {
                const todasSelecionadas = recebimentosLinhas.every((x) => x.selecionado);

                setRecebimentosLinhas((prev) =>
                  prev.map((x) => ({
                    ...x,
                    selecionado: !todasSelecionadas,
                    novo_recebimento: !todasSelecionadas ? Number(x.valor_em_falta || 0) : 0,
                  }))
                );
              }}
            >
              {recebimentosLinhas.every((x) => x.selecionado)
                ? "Desselecionar todas"
                : "Selecionar todas"}
            </MDButton>

            <MDTypography variant="caption">
              Ao selecionar, o novo recebimento é preenchido com o valor em falta.
            </MDTypography>
          </MDBox>

          <MDBox
            sx={{
              maxHeight: { xs: "50vh", md: 420 },
              overflow: "auto",
              maxWidth: "100%",
            }}
          >
            <table
              style={{
                width: "100%",
                minWidth: 980,
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Fatura</th>
                  <th style={{ textAlign: "center", fontSize: 12, padding: 6 }}>Recebida</th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Valor a receber</th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Já recebido</th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Novo recebimento</th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>
                    Total após registo
                  </th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Diferença</th>
                </tr>
              </thead>

              <tbody>
                {recebimentosLinhas.map((r, idx) => {
                  const valorAReceber = Number(r.valor_a_receber || 0);
                  const valorRecebido = Number(r.valor_total_recebido || 0);
                  const novo = Number(r.novo_recebimento || 0);
                  const totalApos = valorRecebido + novo;
                  const diferenca = valorAReceber - totalApos;

                  return (
                    <tr key={r.id}>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        <IconButton
                          size="small"
                          color="info"
                          onClick={() => abrirResultado(r)}
                          title="Detalhe"
                        >
                          <InfoIcon fontSize="small" />
                        </IconButton>
                        {r.faturaorigem}
                      </td>

                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "center",
                        }}
                      >
                        <Checkbox
                          checked={!!r.selecionado}
                          onChange={(e) => {
                            const checked = e.target.checked;

                            setRecebimentosLinhas((prev) =>
                              prev.map((x, i) =>
                                i === idx
                                  ? {
                                      ...x,
                                      selecionado: checked,
                                      novo_recebimento: checked ? Number(x.valor_em_falta || 0) : 0,
                                    }
                                  : x
                              )
                            );
                          }}
                          size="small"
                        />
                      </td>

                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "right",
                        }}
                      >
                        {valorAReceber.toFixed(3)}
                      </td>

                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "right",
                        }}
                      >
                        {valorRecebido.toFixed(3)}
                      </td>

                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "right",
                        }}
                      >
                        <input
                          type="number"
                          step="0.001"
                          value={r.novo_recebimento}
                          onChange={(e) => {
                            const value = e.target.value;

                            setRecebimentosLinhas((prev) =>
                              prev.map((x, i) =>
                                i === idx
                                  ? {
                                      ...x,
                                      novo_recebimento: value,
                                      selecionado: Number(value || 0) !== 0,
                                    }
                                  : x
                              )
                            );
                          }}
                          style={{
                            width: 110,
                            textAlign: "right",
                            padding: 6,
                            borderRadius: 6,
                            border: "1px solid #d2d6da",
                          }}
                        />
                      </td>

                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "right",
                        }}
                      >
                        {totalApos.toFixed(3)}
                      </td>

                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "right",
                          fontWeight: 600,
                        }}
                      >
                        {diferenca.toFixed(3)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </MDBox>

          <MDBox
            mt={2}
            p={{ xs: 1.25, md: 2 }}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              maxWidth: "100%",
              overflowX: "auto",
            }}
          >
            <MDTypography variant="h6" mb={1}>
              Histórico da campanha
            </MDTypography>

            <MDBox
              sx={{
                maxHeight: { xs: "42vh", md: 220 },
                overflow: "auto",
                maxWidth: "100%",
              }}
            >
              <table
                style={{
                  width: "100%",
                  minWidth: isAdminLike ? 860 : 760,
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Data</th>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Fatura</th>
                    <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Valor</th>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Doc/ref.</th>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Obs</th>
                    <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Utilizador</th>
                    {isAdminLike && (
                      <th style={{ textAlign: "center", fontSize: 12, padding: 6 }}>Ações</th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {historicoRecebimentosCampanha.map((h) => (
                    <tr key={h.id}>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {h.datarecebimento}
                      </td>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {h.faturaorigem}
                      </td>
                      <td
                        style={{
                          fontSize: 12,
                          padding: 6,
                          borderTop: "1px solid #eee",
                          textAlign: "right",
                        }}
                      >
                        {Number(h.valor_recebido || 0).toFixed(3)}
                      </td>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {h.docref}
                      </td>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {h.obs}
                      </td>
                      <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                        {h.criado_por_nome || h.criado_por}
                      </td>
                      {isAdminLike && (
                        <td
                          style={{
                            fontSize: 12,
                            padding: 6,
                            borderTop: "1px solid #eee",
                            textAlign: "center",
                          }}
                        >
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => apagarRecebimentoCampanha(h)}
                            title="Apagar recebimento"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </MDBox>
          </MDBox>
        </MDBox>
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>
        <MDButton color="success" onClick={gravarRecebimentos}>
          Gravar recebimentos
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
